import varibles from "@/assets/js/variables";

export default {
  menu: [
    {
      mainGroup: "navmenu.mainGroup.admin",
      canAccessRole: [varibles.roleName.ADMIN],
      components: [
        {
          name: "navmenu.component.users",
          path: "/users",
          canAccessRole: [varibles.roleName.ADMIN],
          icon: "users"
        },
        {
          name: "navmenu.component.partners",
          path: "/partners",
          canAccessRole: [varibles.roleName.ADMIN],
          icon: "partners"
        },
        {
          name: "navmenu.component.movements",
          path: "/movements",
          canAccessRole: [varibles.roleName.ADMIN],
          icon: "movements"
        }
      ]
    },
    {
      mainGroup: "navmenu.mainGroup.user",
      canAccessRole: [
        varibles.roleName.STOREMAN,
        varibles.roleName.DRIVER,
        varibles.roleName.ADMIN
      ],
      components: [
        {
          name: "navmenu.component.byPartner",
          path: "/byPartner",
          canAccessRole: [
            varibles.roleName.STOREMAN,
            varibles.roleName.DRIVER,
            varibles.roleName.ADMIN
          ],
          icon: "byPartners"
        },
        {
          name: "navmenu.component.store",
          path: "/",
          canAccessRole: [
            varibles.roleName.STOREMAN,
            varibles.roleName.DRIVER,
            varibles.roleName.ADMIN
          ],
          icon: "store"
        },
        {
          name: "navmenu.component.delivery",
          path: "/delivery",
          canAccessRole: [
            varibles.roleName.STOREMAN,
            varibles.roleName.DRIVER,
            varibles.roleName.ADMIN
          ],
          icon: "delivery"
        },
        {
          name: "navmenu.component.wash",
          path: "/wash",
          canAccessRole: [varibles.roleName.STOREMAN, varibles.roleName.ADMIN],
          icon: "wash"
        },
        {
          name: "navmenu.component.profile",
          path: "/profile",
          canAccessRole: [
            varibles.roleName.STOREMAN,
            varibles.roleName.DRIVER,
            varibles.roleName.ADMIN
          ],
          icon: "profile"
        }
      ]
    }
  ]
};
